import React, { useState } from "react";
import { COUNTRIES } from "@/data/countries";
import { CountryFlag } from "@/components/ui/country-flag/country-flag";

interface CountryPickerProps {
  onSelect: (countryCode: string) => void;
}

export const CountryPicker: React.FC<CountryPickerProps> = ({ onSelect }) => {
  const [search, setSearch] = useState("");

  const filteredCountries = COUNTRIES.filter((country) =>
    country.name.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="w-full relative">
        <input
          type="text"
          placeholder="Search country..."
          className="w-full bg-white/10 border border-white/20 rounded-xl py-3 px-4 text-white text-md focus:outline-none focus:border-pk-blue-3 transition-colors placeholder:text-white/20"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="w-full max-h-[150px] overflow-y-auto grid grid-cols-5 gap-1 pr-1">
        {filteredCountries
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((country) => (
            <button
              key={country.code}
              className="group flex flex-col items-center gap-2 p-1 bg-white/5 hover:bg-white/10 rounded-xl transition-all border border-transparent hover:border-white/20 active:scale-95"
              onClick={() => onSelect(country.code)}
            >
              <CountryFlag countryCode={country.code} size="md" />
            </button>
          ))}
        {filteredCountries.length === 0 && (
          <p className="col-span-full text-pk-gray-1 text-center py-8 text-sm italic opacity-40">
            No regions found
          </p>
        )}
      </div>
    </div>
  );
};
